module.exports = __webpack_public_path__ + "ef840f9b61ecb8f79522fd39cebfd1ce.MP3";